__turbopack_context__.v({
  "DM_12_24_Link_B": "Welcome-module-scss-module__CN0Aba__DM_12_24_Link_B",
  "DM_14_24_Link_B": "Welcome-module-scss-module__CN0Aba__DM_14_24_Link_B",
  "DM_20_24_Bold": "Welcome-module-scss-module__CN0Aba__DM_20_24_Bold",
  "DM_Body_Reg_16": "Welcome-module-scss-module__CN0Aba__DM_Body_Reg_16",
  "DM_Bold_14_16": "Welcome-module-scss-module__CN0Aba__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "Welcome-module-scss-module__CN0Aba__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "Welcome-module-scss-module__CN0Aba__DM_Bold_16_24",
  "DM_Bold_20_24": "Welcome-module-scss-module__CN0Aba__DM_Bold_20_24",
  "DM_Bold_40_56": "Welcome-module-scss-module__CN0Aba__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "Welcome-module-scss-module__CN0Aba__DM_Btn_16_16_Med",
  "DM_Med_10_12": "Welcome-module-scss-module__CN0Aba__DM_Med_10_12",
  "DM_Med_12_12_Chip": "Welcome-module-scss-module__CN0Aba__DM_Med_12_12_Chip",
  "DM_Med_12_16": "Welcome-module-scss-module__CN0Aba__DM_Med_12_16",
  "DM_Med_14_16": "Welcome-module-scss-module__CN0Aba__DM_Med_14_16",
  "DM_Med_14_20": "Welcome-module-scss-module__CN0Aba__DM_Med_14_20",
  "DM_Med_14_24": "Welcome-module-scss-module__CN0Aba__DM_Med_14_24",
  "DM_Med_16_16": "Welcome-module-scss-module__CN0Aba__DM_Med_16_16",
  "DM_Med_16_24": "Welcome-module-scss-module__CN0Aba__DM_Med_16_24",
  "DM_Med_18_24": "Welcome-module-scss-module__CN0Aba__DM_Med_18_24",
  "DM_Med_20_24": "Welcome-module-scss-module__CN0Aba__DM_Med_20_24",
  "DM_Med_24_24": "Welcome-module-scss-module__CN0Aba__DM_Med_24_24",
  "DM_Med_32_32": "Welcome-module-scss-module__CN0Aba__DM_Med_32_32",
  "DM_Med_32_48": "Welcome-module-scss-module__CN0Aba__DM_Med_32_48",
  "DM_Med_8_8": "Welcome-module-scss-module__CN0Aba__DM_Med_8_8",
  "DM_Reg_10_10": "Welcome-module-scss-module__CN0Aba__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "Welcome-module-scss-module__CN0Aba__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "Welcome-module-scss-module__CN0Aba__DM_Reg_12_16",
  "DM_Reg_14_16": "Welcome-module-scss-module__CN0Aba__DM_Reg_14_16",
  "DM_Reg_14_24": "Welcome-module-scss-module__CN0Aba__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "Welcome-module-scss-module__CN0Aba__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "Welcome-module-scss-module__CN0Aba__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "Welcome-module-scss-module__CN0Aba__DM_Reg_16_20",
  "DM_Reg_16_24": "Welcome-module-scss-module__CN0Aba__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "Welcome-module-scss-module__CN0Aba__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "Welcome-module-scss-module__CN0Aba__DM_Reg_18_28",
  "DM_Reg_32_32": "Welcome-module-scss-module__CN0Aba__DM_Reg_32_32",
  "DM_Reg_40_56": "Welcome-module-scss-module__CN0Aba__DM_Reg_40_56",
  "container": "Welcome-module-scss-module__CN0Aba__container",
  "description": "Welcome-module-scss-module__CN0Aba__description",
  "form": "Welcome-module-scss-module__CN0Aba__form",
  "header": "Welcome-module-scss-module__CN0Aba__header",
  "link": "Welcome-module-scss-module__CN0Aba__link",
  "message": "Welcome-module-scss-module__CN0Aba__message",
  "systemProblemMessage": "Welcome-module-scss-module__CN0Aba__systemProblemMessage",
});
